import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB2D61HFmVFXtxisv9qxSQ1CBzTbJVbedw",
  authDomain: "astology-edfcf.firebaseapp.com",
  projectId: "astology-edfcf",
  storageBucket: "astology-edfcf.firebasestorage.app",
  messagingSenderId: "613008338734",
  appId: "1:613008338734:web:27bfd6648174fc071794bf"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);